import React, { useId } from 'react'
// Utils
import classnames from 'classnames'

import styles from './rangeSlider.module.scss'

export interface RangeSliderProps {
  title: string
  minLabel: string
  maxLabel: string
  percentage: number
  className?: string
  wrapperClassName?: string
}

export const RangleSlider = ({ className = '', ...props }: RangeSliderProps) => {
  const wrapClasses = classnames(styles.rangeSliderWrap, props.wrapperClassName)
  const id = useId()
  return (
    <div className={wrapClasses}>
      <label className={styles.rangeSliderTitle} htmlFor={id}>
        {props.title}
      </label>
      <div className={classnames(styles.rangeSliderLabelContainer, className)}>
        <input
          type="range"
          min="0"
          max="100"
          value={props.percentage}
          className={styles.rangeSlider}
          disabled
          id={id}
        />
        <div className={styles.rangeSliderLabel}>
          <span>{props.minLabel}</span>
          <span>{props.maxLabel}</span>
        </div>
      </div>
    </div>
  )
}

export default RangleSlider
